import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useAuth } from "@/context/AuthContext";
import { playIntroChime } from "@/lib/celebrate";
import { isHalloween } from "@/lib/halloween";

const KEY = "itz_intro_shown";
const DURATION = 3000;

const shouldShow = () => {
  try { return !sessionStorage.getItem(KEY); } catch { return false; }
};

const storedName = () => {
  try { return JSON.parse(localStorage.getItem("itz_splash_user") || "{}").name || ""; } catch { return ""; }
};

export function LogoIntro() {
  const [show, setShow] = useState(shouldShow);
  const [leaving, setLeaving] = useState(false);
  const { user } = useAuth() || {};
  const first = user === false ? "" : (user?.name || "").trim().split(/\s+/)[0] || storedName();
  useEffect(() => {
    if (!show) return undefined;
    try { sessionStorage.setItem(KEY, "1"); } catch { /* private mode */ }
    const reduce = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    const t1 = setTimeout(() => setLeaving(true), reduce ? 900 : DURATION - 450);
    const t2 = setTimeout(() => setShow(false), reduce ? 1200 : DURATION);
    const t3 = setTimeout(playIntroChime, reduce ? 0 : 1000);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, [show]);
  if (!show) return null;
  const skip = () => { setLeaving(true); setTimeout(() => setShow(false), 350); };
  const hw = isHalloween();
  return createPortal(
    <div className={`intro-root ${hw ? "intro-hw" : ""} ${leaving ? "is-leaving" : ""}`} style={hw ? undefined : { backgroundImage: "url(/splash/bg.jpg)" }} onClick={skip} role="presentation" data-testid="logo-intro">
      <div className="intro-glow" />
      {hw && ["8%,14%,0s", "78%,10%,.6s", "16%,72%,1.1s", "84%,66%,.3s"].map((v) => { const [l, t, d] = v.split(","); return <span key={v} className="intro-hw-bat" style={{ left: l, top: t, animationDelay: d }}>🦇</span>; })}
      <div className="intro-logo">
        <img src="/logo-mark.png?v=6" alt="itzPlay" className="intro-img" />
        <span className="intro-shine" />
        <span className="intro-heart-glow" style={{ left: "27.5%", top: "29%" }} />
        <span className="intro-star" style={{ left: "27.5%", top: "29%" }}>
          <span className="intro-star-core" />
          <span className="intro-star-ray" />
          <span className="intro-star-ray r2" />
        </span>
        {[[-8, 30, 0.9], [102, 62, 1.3], [18, 104, 1.6], [70, -6, 1.1], [108, 8, 1.9], [-4, 78, 2.1]].map(([x, y, d], i) => (
          <span key={i} className="intro-twinkle" style={{ left: `${x}%`, top: `${y}%`, animationDelay: `${d}s` }} />
        ))}
      </div>
      <p className="intro-word">itz<span>Play</span></p>
      {first && <p className="intro-hello" data-testid="logo-intro-greeting">{hw ? `Happy Halloween, ${first}! 🎃` : `Schön, dass du da bist, ${first}! 💗`}</p>}
      {!first && hw && <p className="intro-hello" data-testid="logo-intro-greeting">Happy Halloween! 🎃</p>}
    </div>,
    document.body,
  );
}
